export default __webpack_public_path__ + "static/mosquee-d77c762ad6693036bd75214d38221018.webp";